module.exports = __webpack_public_path__ + "img/neutral.a9ef351.svg";